<div class="help">
<h1>Grundraden</h1>
<p>När man reducerar börjar man med att fylla i ett matematiskt system, även kallat grundraden till systemet. Grundraden har en ljusblå färg.</p>

<h2>Teckenförklaring</h2>
  <p><img src="/images/streck.svg" height="16pt" style="vertical-align: text-top;"  alt="Streck" title="Streck"/> <strong>Streck</strong> Svenska folkets streckprocent</p>
  <p><img src="/images/odds.svg" height="16pt" style="vertical-align: text-top;"  alt="Odds" title="Odds"/> <strong>Odds</strong> Svenska spels odds på matchen vid singelspel</p>
  <p><img src="/images/odds-procent.svg" height="16pt" style="vertical-align: text-top;"  alt="Odds%" title="Odds%"/> <strong>Odds%</strong> Svenska spels odds omräknat i procent</p>
  <p><img src="/images/forandring.svg" height="16pt" style="vertical-align: text-top;"  alt="Förändring" title="Förändring"/> <strong>Oddsförändring</strong> Förändring av odds från startoddset</p>
  <p><img src="/images/varde.svg" height="16pt" style="vertical-align: text-top;"  alt="Värde" title="Värde"/> <strong>Värde</strong> En vägning av spelvärdet baserat på odds/streck</p>

<h1>Reducering</h1>
När man har fyllt i sin grundrad kan man börja reducera bort rader från systemet. De olika typerna av reduceringsmetoder visas här.

<h2><img src="/images/minmax.svg" height="14pt" style="filter:invert(100%);"  alt="MinMax" title="MinMax"/> Reducera efter färger</h2>
<p>Här kan man reducera rader efter färggrupper. Genom att ge tecken en färg kan man bestämma hur många tecken av den färgen som får förkomma i varje rad i systemet.</p>
<p>Ett exempel kan vara om man bara vill ha med rader där max tre och minst en av de fyra största favoriterna vinner. Då markerar man de fyra tecknen med en färg och fyller i att minst en och max tre av den färgen får vara med i samma rad.</p>

<h2><img src="/images/minmax2.svg" height="20pt" style="vertical-align: text-top;filter:invert(100%);"  alt="MinMax" title="MinMax"/> Reducera efter tecken</h2>
<p>Här kan man filtrera bort rader efter hur många av ett visst tecken som får förekomma i systemet. Om man exempelvis vill ha med max fem kryss i varje enskild rad på systemet kan man fylla i det här.</p>

<h2><img src="/images/moneybag.svg" height="20pt" style="vertical-align: text-top;filter:invert(100%);"  alt="Utdelning" title="Utdelning"/> Reducera efter utdelning</h2>
<p>Här kan man filtrera bort rader efter den beräknade utdelningen vid 13 rätt. Utdelningen är uppskattad efter hur strecken är fördelade i varje match. Eftersom att det är en uppskattning innebär det att den verkliga utdelningen kan skilja sig från vad programmet beräknar, men den ger ett bra hum om ungefär var utdelningen kommer ligga.</p>
<p>Den här filtreringen kan vara bra att använda om man vill reducera bort de svåraste eller lättaste raderna.</p>

<h1>Info om systemet och inlämning</h1>
<p>När man är klar med sina reduceringar trycker man på knappen ”Reducera” under kupongen för att få information om det reducerade systemet. Då ser man hur stort det reducerade systemet är samt beräknad minimal, medel och maximal utdelning.
Tabellen visar hur raderna i är fördelade i varje match.</p>
<p>Stapeldiagrammet visar den uppskattade utdelningen för systemets alla rader. Här finns även en bild på systemet och dess krav som man kan högerklicka på och kopiera för att dela med sig av sitt system.
Spelet lämnas in till Svenska spel med den gröna knappen.</p>
</div>

<style>
.help {
  text-align: left;
  font-size: 10pt;
}

.help h1 {
  font-size: 16pt;
  border-bottom: 1pt solid #e9e9e9;
}

.help h2 {
  font-size: 12pt;
}

.help h1, .help h2 {
  padding-top: 5pt;  
}
</style>